import React from 'react';
import MaxPrepsErrorComponent from '../../corecomponents/ErrorPage/MaxPrepsErrorComponent';
import { IRouteUrlHistory } from './../../hooks/useRouteUrlHistory';

/**
 * pageConfig is for the page the user tried to load (ie. /team/roster/default) but because it was
 * a GSSP error we are going to show the MaxPrepsErrorComponent instead
 * @param {*} pageConfig
 * @param {*} projectMetaData
 * @param {*} pageViewGuid
 * @param {*} deviceType
 * @param {*} isAdmin
 * @param {*} gsspError
 * @returns
 */
export const getAppEarlyReturnGSSPErrorComponent = (
  pageConfig,
  projectMetaData,
  pageViewGuid,
  deviceType,
  isAdmin,
  gsspError
) => {
  // For SSR errors
  if (gsspError?.statusCode >= 400) {
    return (
      <MaxPrepsErrorComponent
        projectMetaData={projectMetaData}
        pageMetaData={pageConfig?.pageMetaData ?? {}}
        deviceType={deviceType}
        pageViewGuid={pageViewGuid}
        isAdmin={isAdmin}
        {...gsspError}
      />
    );
  }
};

/**
 * Component is going to be an instance of 'MaxPrepsErrorComponent'
 * This is auto-mapped by next when an unhandled error occurs in the gssp phase
 * @param {*} Component
 * @param {*} pageConfig
 * @param {*} projectMetaData
 * @param {*} pageViewGuid
 * @param {*} deviceType
 * @param {*} isAdmin
 * @param {*} statusCode
 * @param {*} title
 * @param  {...any} restOfPageProps
 * @returns
 */
export const getAppEarlyReturnComponent = (
  Component,
  pageConfig,
  projectMetaData,
  pageViewGuid,
  deviceType,
  isAdmin,
  statusCode,
  title,
  restOfPageProps,
  routeUrlHistory: IRouteUrlHistory
) => {
  // for static generation
  if (pageConfig?.earlyReturn) {
    return (
      <Component
        projectMetaData={projectMetaData}
        pageMetaData={pageConfig?.pageMetaData ?? {}}
        deviceType={deviceType}
        pageViewGuid={pageViewGuid}
        isAdmin={isAdmin}
        statusCode={statusCode}
        title={title}
        routeUrlHistory={routeUrlHistory}
        {...restOfPageProps}
      />
    );
  }
};
